import { createAction } from "@reduxjs/toolkit";
import { User } from "../session.types";

export const login = createAction<User>("session/login");

export const logout = createAction("session/logout");
